import {
  FETCH_ROLE,
  FETCH_ROLE_SUCCESS,
  FETCH_ROLE_ERROR,
  ADD_ROLE,
  ADD_ROLE_SUCCESS,
  ADD_ROLE_ERROR,
  RESET_ADD_ROLE,
  UPDATE_ROLE,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_ERROR,
  DELETE_ROLE,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_ERROR,
} from "constants/ActionTypes";

export const fetchRole = (params) => {
  return {
    type: FETCH_ROLE,
    params,
  }
};

export const fetchRoleSuccess = (RoleList) => {
  return {
    type: FETCH_ROLE_SUCCESS,
    payload: RoleList,
  }
};

export const fetchRoleError = (error) => {
  return {
    type: FETCH_ROLE_ERROR,
    payload: error
  }
};

export const addRole = (payload) => {
  return {
    type: ADD_ROLE,
    payload,
  }
};

export const addRoleSuccess = (payload) => {
  return {
    type: ADD_ROLE_SUCCESS,
    payload,
  }
};

export const addRoleError = (error) => {
  return {
    type: ADD_ROLE_ERROR,
    payload: error
  }
};

export const updateRole = (payload) => {
  return {
    type: UPDATE_ROLE,
    payload,
  }
};

export const updateRoleSuccess = (payload) => {
  return {
    type: UPDATE_ROLE_SUCCESS,
    payload,
  }
};

export const updateRoleError = (error) => {
  return {
    type: UPDATE_ROLE_ERROR,
    payload: error
  }
};

export const deleteRole = (payload) => {
  return {
    type: DELETE_ROLE,
    payload,
  }
};

export const deleteRoleSuccess = (payload) => {
  return {
    type: DELETE_ROLE_SUCCESS,
    payload,
  }
};

export const deleteRoleError = (error) => {
  return {
    type: DELETE_ROLE_ERROR,
    payload: error
  }
};

export const resetAddRole = () => {
  return {
    type: RESET_ADD_ROLE,
  }
};
